export const FETCH_CREATE_BH_REQUEST = 'FETCH_CREATE_BH_REQUEST';
export const FETCH_CREATE_BH_SUCCESS = 'FETCH_CREATE_BH_SUCCESS';
export const FETCH_CREATE_BH_FAILED = 'FETCH_CREATE_BH_FAILED';

export const RESET_BH = 'RESET_BH';
export const DELETE_BH = 'DELETE_BH';
export const UPDATE_CURRENT_BUSINESS_HOURS = 'UPDATE_CURRENT_BUSINESS_HOURS';

export const FETCH_BH_BY_ID_REQUEST = 'FETCH_BH_BY_ID_REQUEST';
export const FETCH_BH_BY_ID_SUCCESS = 'FETCH_BH_BY_ID_SUCCESS';
export const FETCH_BH_BY_ID_FAILED = 'FETCH_BH_BY_ID_FAILED';

export const FETCH_UPDATE_BH_REQUEST = 'FETCH_UPDATE_BH_REQUEST';
export const FETCH_UPDATE_BH_SUCCESS = 'FETCH_UPDATE_BH_SUCCESS';
export const FETCH_UPDATE_BH_FAILED = 'FETCH_UPDATE_BH_FAILED';

export const FETCH_OVERWRITE_BH_REQUEST = 'FETCH_OVERWRITE_BH_REQUEST';
export const FETCH_OVERWRITE_BH_SUCCESS = 'FETCH_OVERWRITE_BH_SUCCESS';
export const FETCH_OVERWRITE_BH_FAILED = 'FETCH_OVERWRITE_BH_FAILED';

export const FETCH_BUSINESS_HOURS_REQUEST = 'FETCH_BUSINESS_HOURS_REQUEST';
export const FETCH_BUSINESS_HOURS_SUCCESS = 'FETCH_BUSINESS_HOURS_SUCCESS';
export const FETCH_BUSINESS_HOURS_FAILED = 'FETCH_BUSINESS_HOURS_FAILED';

export const FETCH_ASSOCIATED_VEHICLE_GROUPS_REQUEST = 'FETCH_ASSOCIATED_VEHICLE_GROUPS_REQUEST';
export const FETCH_ASSOCIATED_VEHICLE_GROUPS_SUCCESS = 'FETCH_ASSOCIATED_VEHICLE_GROUPS_SUCCESS';
export const FETCH_ASSOCIATED_VEHICLE_GROUPS_FAILED = 'FETCH_ASSOCIATED_VEHICLE_GROUPS_FAILED';
